export default __webpack_public_path__ + "static/media/gardening.bde1e4a5.jpeg";